/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import vue from "vue";
import wxApi from "@/utils/utils";
import { setToken } from "@/utils/cookies";
import store from "../store";
import { imagesUpdate } from "@/api/common";

// 初始化
export function AppInit() {
  var token = "";
  setToken(token);
  store.dispatch("SetToken", token);
  wxAuthorization();
}
// 发起微信授权
export function wxAuthorization() {
  var href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx095143e388c01d6c&redirect_uri=https%3A%2F%2Fwx-pp.ndstyzx.cn%2F%23%2Flogin%3Fv%3Dningde&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect";
  location.href = href;
}
// 获取定位
export function getLocation() {
  wxApi.wxTkt(function () {
    var times = 0;
    var timer = null;
    vue.wechat.getLocation({
      type: "wgs84",
      // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
      success: function success(res) {
        times = times + 1;
        clearInterval(timer);
        sessionStorage.setItem("lat", res.latitude); // 纬度，浮点数，范围为90 ~ -90
        sessionStorage.setItem("lng", res.longitude); // 经度，浮点数，范围为180 ~ -180
      },
      cancel: function cancel(res) {},
      error: function error(res) {}
    });
    timer = setInterval(function () {
      if (times > 0) {
        clearInterval(timer);
        return false;
      }
      vue.wechat.getLocation({
        type: "wgs84",
        // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
        success: function success(res) {
          clearInterval(timer);
          sessionStorage.setItem("lat", res.latitude); // 纬度，浮点数，范围为90 ~ -90
          sessionStorage.setItem("lng", res.longitude); // 经度，浮点数，范围为180 ~ -180
        },
        cancel: function cancel(res) {},
        error: function error(res) {}
      });
    }, 20000);
  });
}
// 唤起扫一扫
export function scanQrcode(callBack) {
  wxApi.wxTkt(function () {
    vue.wechat.scanQRCode({
      needResult: 1,
      // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
      scanType: ["qrCode"],
      // 可以指定扫二维码还是一维码，默认二者都有
      success: function success(res) {
        if (typeof callBack === "function") {
          callBack(res);
        }
      }
    });
  });
}
// 拍照上传头像
export function uploadImage(callBack, dir) {
  wxApi.wxTkt(function () {
    // 图片名称（feedbackImg：反馈图片；actionImg：工单处理图片）
    // console.log('wxTkt')
    // alert('wxTkt')
    vue.wechat.chooseImage({
      count: 1,
      // 默认9
      sizeType: ["compressed"],
      // 可以指定是原图还是压缩图，默认二者都有
      sourceType: ["album", "camera"],
      // 可以指定来源是相册还是相机，默认二者都有
      success: function success(res) {
        var localIds = res.localIds[0]; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
        vue.wechat.uploadImage({
          localId: localIds,
          // 需要上传的图片的本地ID，由chooseImage接口获得
          isShowProgressTips: 1,
          // 默认为1，显示进度提示
          success: function success(res) {
            // console.log('uploadImage')
            // alert('uploadImage')
            var serverId = res.serverId; // 返回图片的服务器端ID
            var data = {
              mediaId: serverId,
              dir: dir
            };
            imagesUpdate(data).then(function (res) {
              callBack(res.data);
              // self.src = res.data.imgUrl
              // self.user_avatar = res.data.imgPath
            });
          }
        });
      }
    });
  });
}

// IOS兼容软键盘关闭函数
export function inputCheckIOS() {
  var u = navigator.userAgent;
  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
  var scroll = document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop;
  if (isiOS && scroll) {
    window.scrollTo(0, 1);
  }
}